var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _rect, _path40;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 177,
    viewBox: "0 0 204 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M17.9111 94.1483C0.139876 160.72 74.1002 174.876 142.839 161.166C211.578 147.455 213.839 109.879 165.935 67.602C118.031 25.3254 35.6823 27.577 17.9111 94.1483Z",
    fill: "#B0B3F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.455 143.179C170.331 143.179 167.77 145.74 167.77 148.863C167.77 151.987 170.331 154.548 173.455 154.548C176.579 154.548 179.14 151.987 179.14 148.863C179.14 145.74 176.579 143.179 173.455 143.179ZM163.902 148.863C163.902 143.603 168.195 139.311 173.455 139.311C178.715 139.311 183.008 143.603 183.008 148.863C183.008 154.124 178.715 158.416 173.455 158.416C168.195 158.416 163.902 154.124 163.902 148.863Z",
    fill: "#CC2364"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M6.28842 113.067C6.28842 111.542 5.0521 110.305 3.52702 110.305C2.00194 110.305 0.765625 111.542 0.765625 113.067C0.765625 114.592 2.00194 115.828 3.52702 115.828C5.0521 115.828 6.28842 114.592 6.28842 113.067Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M25.5531 113.067C25.5531 111.542 24.3167 110.305 22.7917 110.305C21.2666 110.305 20.0303 111.542 20.0303 113.067C20.0303 114.592 21.2666 115.828 22.7917 115.828C24.3167 115.828 25.5531 114.592 25.5531 113.067Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M44.848 113.067C44.848 111.542 43.6117 110.305 42.0866 110.305C40.5615 110.305 39.3252 111.542 39.3252 113.067C39.3252 114.592 40.5615 115.828 42.0866 115.828C43.6117 115.828 44.848 114.592 44.848 113.067Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M64.1126 113.067C64.1126 111.542 62.8763 110.305 61.3512 110.305C59.8262 110.305 58.5898 111.542 58.5898 113.067C58.5898 114.592 59.8262 115.828 61.3512 115.828C62.8763 115.828 64.1126 114.592 64.1126 113.067Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M83.3744 113.067C83.3744 111.542 82.138 110.305 80.613 110.305C79.0879 110.305 77.8516 111.542 77.8516 113.067C77.8516 114.592 79.0879 115.828 80.613 115.828C82.138 115.828 83.3744 114.592 83.3744 113.067Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M102.639 113.067C102.639 111.542 101.403 110.305 99.8776 110.305C98.3525 110.305 97.1162 111.542 97.1162 113.067C97.1162 114.592 98.3525 115.828 99.8776 115.828C101.403 115.828 102.639 114.592 102.639 113.067Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M6.28842 132.328C6.28842 130.803 5.0521 129.567 3.52702 129.567C2.00194 129.567 0.765625 130.803 0.765625 132.328C0.765625 133.854 2.00194 135.09 3.52702 135.09C5.0521 135.09 6.28842 133.854 6.28842 132.328Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M25.5531 132.328C25.5531 130.803 24.3167 129.567 22.7917 129.567C21.2666 129.567 20.0303 130.803 20.0303 132.328C20.0303 133.854 21.2666 135.09 22.7917 135.09C24.3167 135.09 25.5531 133.854 25.5531 132.328Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M44.848 132.328C44.848 130.803 43.6117 129.567 42.0866 129.567C40.5615 129.567 39.3252 130.803 39.3252 132.328C39.3252 133.854 40.5615 135.09 42.0866 135.09C43.6117 135.09 44.848 133.854 44.848 132.328Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M64.1126 132.328C64.1126 130.803 62.8763 129.567 61.3512 129.567C59.8262 129.567 58.5898 130.803 58.5898 132.328C58.5898 133.854 59.8262 135.09 61.3512 135.09C62.8763 135.09 64.1126 133.854 64.1126 132.328Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M83.3744 132.328C83.3744 130.803 82.138 129.567 80.613 129.567C79.0879 129.567 77.8516 130.803 77.8516 132.328C77.8516 133.854 79.0879 135.09 80.613 135.09C82.138 135.09 83.3744 133.854 83.3744 132.328Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M102.639 132.328C102.639 130.803 101.403 129.567 99.8776 129.567C98.3525 129.567 97.1162 130.803 97.1162 132.328C97.1162 133.854 98.3525 135.09 99.8776 135.09C101.403 135.09 102.639 133.854 102.639 132.328Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M6.28842 151.625C6.28842 150.1 5.0521 148.864 3.52702 148.864C2.00194 148.864 0.765625 150.1 0.765625 151.625C0.765625 153.15 2.00194 154.387 3.52702 154.387C5.0521 154.387 6.28842 153.15 6.28842 151.625Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M25.5531 151.625C25.5531 150.1 24.3167 148.864 22.7917 148.864C21.2666 148.864 20.0303 150.1 20.0303 151.625C20.0303 153.15 21.2666 154.387 22.7917 154.387C24.3167 154.387 25.5531 153.15 25.5531 151.625Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M44.848 151.625C44.848 150.1 43.6117 148.864 42.0866 148.864C40.5615 148.864 39.3252 150.1 39.3252 151.625C39.3252 153.15 40.5615 154.387 42.0866 154.387C43.6117 154.387 44.848 153.15 44.848 151.625Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M64.1126 151.625C64.1126 150.1 62.8763 148.864 61.3512 148.864C59.8262 148.864 58.5898 150.1 58.5898 151.625C58.5898 153.15 59.8262 154.387 61.3512 154.387C62.8763 154.387 64.1126 153.15 64.1126 151.625Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M83.3744 151.625C83.3744 150.1 82.138 148.864 80.613 148.864C79.0879 148.864 77.8516 150.1 77.8516 151.625C77.8516 153.15 79.0879 154.387 80.613 154.387C82.138 154.387 83.3744 153.15 83.3744 151.625Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M102.639 151.625C102.639 150.1 101.403 148.864 99.8776 148.864C98.3525 148.864 97.1162 150.1 97.1162 151.625C97.1162 153.15 98.3525 154.387 99.8776 154.387C101.403 154.387 102.639 153.15 102.639 151.625Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M186.164 6.67123C187.689 6.67123 188.925 5.43491 188.925 3.90983C188.925 2.38475 187.689 1.14844 186.164 1.14844C184.639 1.14844 183.402 2.38475 183.402 3.90983C183.402 5.43491 184.639 6.67123 186.164 6.67123Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M186.164 25.9369C187.689 25.9369 188.925 24.7005 188.925 23.1755C188.925 21.6504 187.689 20.4141 186.164 20.4141C184.639 20.4141 183.402 21.6504 183.402 23.1755C183.402 24.7005 184.639 25.9369 186.164 25.9369Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M186.164 45.2298C187.689 45.2298 188.925 43.9935 188.925 42.4684C188.925 40.9433 187.689 39.707 186.164 39.707C184.639 39.707 183.402 40.9433 183.402 42.4684C183.402 43.9935 184.639 45.2298 186.164 45.2298Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M186.164 64.4955C187.689 64.4955 188.925 63.2591 188.925 61.7341C188.925 60.209 187.689 58.9727 186.164 58.9727C184.639 58.9727 183.402 60.209 183.402 61.7341C183.402 63.2591 184.639 64.4955 186.164 64.4955Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M186.164 83.7572C187.689 83.7572 188.925 82.5209 188.925 80.9958C188.925 79.4707 187.689 78.2344 186.164 78.2344C184.639 78.2344 183.402 79.4707 183.402 80.9958C183.402 82.5209 184.639 83.7572 186.164 83.7572Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M186.164 103.021C187.689 103.021 188.925 101.785 188.925 100.259C188.925 98.7344 187.689 97.498 186.164 97.498C184.639 97.498 183.402 98.7344 183.402 100.259C183.402 101.785 184.639 103.021 186.164 103.021Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M166.902 6.67123C168.427 6.67123 169.663 5.43491 169.663 3.90983C169.663 2.38475 168.427 1.14844 166.902 1.14844C165.377 1.14844 164.141 2.38475 164.141 3.90983C164.141 5.43491 165.377 6.67123 166.902 6.67123Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M166.902 25.9369C168.427 25.9369 169.663 24.7005 169.663 23.1755C169.663 21.6504 168.427 20.4141 166.902 20.4141C165.377 20.4141 164.141 21.6504 164.141 23.1755C164.141 24.7005 165.377 25.9369 166.902 25.9369Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M166.902 45.2298C168.427 45.2298 169.663 43.9935 169.663 42.4684C169.663 40.9433 168.427 39.707 166.902 39.707C165.377 39.707 164.141 40.9433 164.141 42.4684C164.141 43.9935 165.377 45.2298 166.902 45.2298Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M166.902 64.4955C168.427 64.4955 169.663 63.2591 169.663 61.7341C169.663 60.209 168.427 58.9727 166.902 58.9727C165.377 58.9727 164.141 60.209 164.141 61.7341C164.141 63.2591 165.377 64.4955 166.902 64.4955Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M166.902 83.7572C168.427 83.7572 169.663 82.5209 169.663 80.9958C169.663 79.4707 168.427 78.2344 166.902 78.2344C165.377 78.2344 164.141 79.4707 164.141 80.9958C164.141 82.5209 165.377 83.7572 166.902 83.7572Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M166.902 103.021C168.427 103.021 169.663 101.785 169.663 100.259C169.663 98.7344 168.427 97.498 166.902 97.498C165.377 97.498 164.141 98.7344 164.141 100.259C164.141 101.785 165.377 103.021 166.902 103.021Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M147.604 6.67123C149.129 6.67123 150.366 5.43491 150.366 3.90983C150.366 2.38475 149.129 1.14844 147.604 1.14844C146.079 1.14844 144.843 2.38475 144.843 3.90983C144.843 5.43491 146.079 6.67123 147.604 6.67123Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M147.604 64.4955C149.129 64.4955 150.366 63.2591 150.366 61.7341C150.366 60.209 149.129 58.9727 147.604 58.9727C146.079 58.9727 144.843 60.209 144.843 61.7341C144.843 63.2591 146.079 64.4955 147.604 64.4955Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M147.604 83.7572C149.129 83.7572 150.366 82.5209 150.366 80.9958C150.366 79.4707 149.129 78.2344 147.604 78.2344C146.079 78.2344 144.843 79.4707 144.843 80.9958C144.843 82.5209 146.079 83.7572 147.604 83.7572Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M147.604 103.021C149.129 103.021 150.366 101.785 150.366 100.259C150.366 98.7344 149.129 97.498 147.604 97.498C146.079 97.498 144.843 98.7344 144.843 100.259C144.843 101.785 146.079 103.021 147.604 103.021Z",
    fill: "#BDC0FF",
    stroke: "#BDC0FF",
    strokeWidth: 1.2965,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5831 62.8387C26.4592 62.8387 23.8983 65.3996 23.8983 68.5235C23.8983 71.6474 26.4592 74.2083 29.5831 74.2083C32.707 74.2083 35.2679 71.6474 35.2679 68.5235C35.2679 65.3996 32.707 62.8387 29.5831 62.8387ZM20.0303 68.5235C20.0303 63.2634 24.323 58.9707 29.5831 58.9707C34.8432 58.9707 39.1359 63.2634 39.1359 68.5235C39.1359 73.7836 34.8432 78.0763 29.5831 78.0763C24.323 78.0763 20.0303 73.7836 20.0303 68.5235Z",
    fill: "#CC2364"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M153.796 44.1391C154.345 44.8405 153.772 45.8548 152.888 45.7478L127.969 42.7286C127.421 42.6622 127.03 42.1639 127.097 41.6156L130.124 16.632C130.231 15.7469 131.355 15.434 131.904 16.1364L153.796 44.1391Z",
    fill: "#555893"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9835 3.41418L122.547 10.3884L118.174 46.4787C117.849 49.1654 119.754 51.6065 122.43 51.9307L158.421 56.2912L147.855 143.498C147.53 146.185 145.096 148.1 142.42 147.776L48.8663 136.441C46.1902 136.117 44.2846 133.676 44.6101 130.989L59.5484 7.69203C59.8739 5.00529 62.3074 3.08996 64.9835 3.41418Z",
    fill: "#333966"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 74.8604,
    y: 21.8965,
    width: 12.9068,
    height: 10.3619,
    rx: 5.18095,
    transform: "rotate(6.90811 74.8604 21.8965)",
    fill: "#F5F5F5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4965 115.927C89.2093 118.298 87.0546 119.987 84.684 119.7L67.6161 117.632C65.2454 117.345 63.5565 115.19 63.8437 112.819C64.1309 110.449 66.2856 108.76 68.6562 109.047L85.7241 111.115C88.0948 111.402 89.7837 113.557 89.4965 115.927ZM91.5767 98.7577C91.2895 101.128 89.1349 102.817 86.7642 102.53L69.6963 100.462C67.3257 100.175 65.6367 98.0203 65.924 95.6497C66.2112 93.279 68.3658 91.59 70.7365 91.8773L87.8043 93.9452C90.175 94.2324 91.8639 96.387 91.5767 98.7577ZM94.6971 73.0029C94.4099 75.3736 92.2552 77.0626 89.8846 76.7753L85.6261 76.2594L85.104 80.5688C84.8179 82.9301 82.6718 84.6124 80.3105 84.3263C77.9492 84.0402 76.267 81.8941 76.5531 79.5328L77.0752 75.2234L72.8167 74.7075C70.4461 74.4202 68.7571 72.2656 69.0443 69.8949C69.3315 67.5243 71.4862 65.8353 73.8568 66.1225L78.1153 66.6385L78.6374 62.329C78.9235 59.9678 81.0696 58.2855 83.4309 58.5716C85.7922 58.8577 87.4744 61.0038 87.1883 63.365L86.6662 67.6745L90.9247 68.1904C93.2953 68.4777 94.9843 70.6323 94.6971 73.0029ZM120.625 114.08C122.088 115.953 121.76 118.656 119.893 120.125C118.015 121.603 115.294 121.274 113.823 119.39L111.179 116.002L107.801 118.66C105.924 120.138 103.202 119.809 101.732 117.925C100.269 116.052 100.597 113.349 102.464 111.879L105.868 109.2L103.202 105.785C101.74 103.912 102.068 101.209 103.935 99.7397C105.813 98.2617 108.534 98.5914 110.005 100.475L112.649 103.863L116.026 101.205C117.904 99.7267 120.626 100.056 122.096 101.94C123.559 103.813 123.231 106.516 121.364 107.986L117.96 110.665L120.625 114.08ZM128.901 77.147C128.614 79.5176 126.459 81.2066 124.088 80.9194L107.02 78.8515C104.65 78.5642 102.961 76.4096 103.248 74.039C103.535 71.6683 105.69 69.9793 108.061 70.2666L125.128 72.3344C127.499 72.6217 129.188 74.7763 128.901 77.147Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMath);
export default __webpack_public_path__ + "static/media/math.35881657.svg";
export { ForwardRef as ReactComponent };